import { useTranslation } from "react-i18next";
import LegalPage, { type LegalSection } from "./LegalPage";

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const sections = t("legal.privacy.sections", { returnObjects: true }) as LegalSection[];

  return (
    <LegalPage
      title={t("common.legal.privacyPolicy")}
      updated={t("legal.privacy.updated")}
      sections={sections}
    />
  );
}
